import type { TIsErrorFn, TMeta } from './models';
import { isPhoneError, isError, isBirthdayError } from './is-error';

export const createCaption =
    (isErrorFn: TIsErrorFn) =>
    (meta: TMeta, caption = '', value?: string) => {
        if (isErrorFn(meta, value)) {
            return meta.error || meta.submitError;
        }

        return caption;
    };

export const getCaption = createCaption(isError);
export const getPhoneCaption = createCaption(isPhoneError);
// Для корректной работы у формы должен быть пропс validateOnBlur={false}
export const getBirthdayCaption = createCaption(isBirthdayError);
